import * as React from 'react'

interface SelectedButtonOrNotProps {
    page: number
    selectedPage: number
    onSelectPageFn: (page: number) => void
}

const SelectedButtonOrNot = (props: SelectedButtonOrNotProps) => {
    const {selectedPage,page,onSelectPageFn} = props

    if(selectedPage == page) {
        return <button onClick={() => onSelectPageFn(page)} className='btn btn-danger btn-sm'>{page}</button>
    }
    else{
        return <button onClick={() => onSelectPageFn(page)} className='btn btn-default btn-sm'>{page}</button>
    }
}

interface PagesDisplayProps{
    selectedPage: number
    lastPage: number
    onSelectPageFn: (page: number) => void
}

export const PagesDisplay = (props: PagesDisplayProps) => {
    const {selectedPage,lastPage,onSelectPageFn} = props

    let pageNumbers = Array.apply(0, {length: (lastPage+1)}).map(Number.call, Number)
    pageNumbers.shift()

    return(<div className='btn-group'>
        {pageNumbers.map(number => <SelectedButtonOrNot key={number} page={number} selectedPage={selectedPage} onSelectPageFn={onSelectPageFn}/>) }
    </div>)
}


/** WEBPACK FOOTER **
 ** C:/BIZJ/Code/Business/Flexxus/Flexxus.Web/Scripts/flexxus-references-app/src/components/PagesDisplay.tsx
 **/